import Airbnb from '../../../../../../../../public/assets/img/otas/airbnb-logo-long.png';
import Vrbo from '../../../../../../../../public/assets/img/otas/vrbo-logo-long.png';
import Savvy from '../../../../../../../../public/assets/svg/logos/savvy_wordmark_slate.svg';
import { OtaInfoMap } from './types';

export const ota_info: OtaInfoMap = {
  savvy: { url: undefined, name: 'Savvy', icon: Savvy },
  airbnb: { url: undefined, name: 'airbnb', icon: Airbnb },
  vrbo: { url: undefined, name: 'vrbo', icon: Vrbo },
};

type OtaUrlConfig = {
  baseUrlKey: keyof OtaInfoMap;
  getSearchParams: (params: {
    checkInDate?: string;
    checkOutDate?: string;
    adultCount: number;
    childCount: number;
    infantCount: number;
  }) => Record<string, string>;
};

const otaUrlConfigs: Record<string, OtaUrlConfig> = {
  airbnb: {
    baseUrlKey: 'airbnb',
    getSearchParams: ({
      checkInDate,
      checkOutDate,
      adultCount,
      childCount,
      infantCount,
    }) => ({
      check_in: checkInDate || '',
      check_out: checkOutDate || '',
      adults: adultCount.toString(),
      children: childCount.toString(),
      infants: infantCount.toString(),
      guests: (adultCount + childCount + infantCount).toString(),
    }),
  },
  vrbo: {
    baseUrlKey: 'vrbo',
    getSearchParams: ({
      checkInDate,
      checkOutDate,
      adultCount,
      childCount,
    }) => ({
      adults: (adultCount + childCount).toString(),
      startDate: checkInDate || '',
      endDate: checkOutDate || '',
      chkin: checkInDate || '',
      chkout: checkOutDate || '',
    }),
  },
};

export const constructOtaUrl = (
  quote: { externalSource?: string | null },
  {
    checkInDate,
    checkOutDate,
    adultCount,
    childCount,
    infantCount,
    otaInfo,
  }: {
    checkInDate?: string;
    checkOutDate?: string;
    adultCount: number;
    childCount: number;
    infantCount: number;
    otaInfo: OtaInfoMap;
  }
) => {
  if (!quote.externalSource) return '';

  const source = quote.externalSource.toLowerCase();
  const config = otaUrlConfigs[source];
  if (!config) return '';

  const baseUrl = otaInfo[config.baseUrlKey].url;
  if (!baseUrl) return '';

  const searchParams = new URLSearchParams(
    config.getSearchParams({
      checkInDate,
      checkOutDate,
      adultCount,
      childCount,
      infantCount,
    })
  );

  return `${baseUrl.split('?')[0]}?${searchParams.toString()}`;
};
